export default class BannerQuicklinkBox {
  constructor($toggleButton) {
    this.$toggleButton = $toggleButton;
    this.$list = document.getElementById(this.$toggleButton.getAttribute('aria-controls'));
    this.$items = this.$list.querySelectorAll('.banner-quicklink-box__item');

    this.bindedOnOverlayClose = this.onOverlayClose.bind(this);
    this.bindedOnClick = this.onClick.bind(this);
    this.bindedOnKeypress = this.onKeypress.bind(this);
    this.onOutsideClickBinded = this.onOutsideClick.bind(this);

    document.addEventListener('overlayClose', this.bindedOnOverlayClose);
    this.$toggleButton.addEventListener('click', this.bindedOnClick);

    // avoid tab navigation on items when closed
    this.$items.forEach(($item) => { const $i = $item; $i.hidden = true; });
  }

  closeList() {
    this.$toggleButton.setAttribute('aria-expanded', false);
    this.$items.forEach(($item) => { const $i = $item; $i.hidden = true; });

    document.removeEventListener('keydown', this.bindedOnKeypress);
    document.removeEventListener('click', this.onOutsideClickBinded);
  }

  openList() {
    this.$toggleButton.setAttribute('aria-expanded', true);
    this.$items.forEach(($item) => { const $i = $item; $i.hidden = false; });

    document.addEventListener('keydown', this.bindedOnKeypress);
    ['click', 'focusin'].forEach(type => document.addEventListener(type, this.onOutsideClickBinded));
  }

  onOverlayClose() {
    window.requestAnimationFrame(() => this.closeList());
  }

  onClick(event) {
    const isClosed = this.$toggleButton.getAttribute('aria-expanded') !== 'true';

    window.requestAnimationFrame(() => {
      if (isClosed) {
        this.openList();
      } else {
        this.closeList();
        this.$toggleButton.focus();
      }
    });

    event.preventDefault();
  }

  onKeypress(event) {
    const isOpen = this.$toggleButton.getAttribute('aria-expanded') === 'true';

    // Close on esc-key
    if (isOpen && event.keyCode === 27) {
      window.requestAnimationFrame(() => {
        this.closeList();
        this.$toggleButton.focus();
      });
    }
  }

  onOutsideClick(event) {
    const $target = event.target;

    if ($target) {
      const isInside = $target === this.$list || this.$list.contains($target);
      const isButton = $target === this.$toggleButton || this.$toggleButton.contains($target);

      if (!isInside && !isButton) {
        this.closeList();
      }
    }
  }
}

document.querySelectorAll('.banner-quicklink-box__title').forEach($toggle => new BannerQuicklinkBox($toggle));
